export default __webpack_public_path__ + "static/media/visibility_over.25d0890a.svg";